import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import { submitElectricityLeadsRequest } from "./services";

export const useSubmitElectricityLeads = () =>
  useMutation({
    mutationFn: submitElectricityLeadsRequest,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["bannerMessages"],
      });
    },
  });
